<template>
       <div class="hero-head-about">
      <div class="row row-text">
        <div class="col s1 m1 l1 empty-col"></div>
        <div class="col s12 m12 l10 text-align-center cta-col">
          <h1 class="style-signup">{{ translation('Igotu.96') }}</h1><br />
          <hr class="hr-class" />
          <span class="light disclaimer">{{ translation('Igotu.96') }}</span><br />

          <a class="btn-large" @click="goToRegister()">
            {{ translation('item.sign.in') }}
          </a>
        </div>
        <div class="col s1 m1 l1 empty-col"></div>
      </div>
      <br /><br />
    </div>
</template>

<script>
import translationStore from '@/store/translations'

export default {
  data () {
    return {
      translationStore: translationStore
    }
  },
  computed: {
    translation () {
      return translationStore.getters.traduzione
    }
  },
  methods: {
    goToRegister () {
      this.$router.push('/registration')
    }
  }
}
</script>
<style>
.hero-head-about{
      background-color: var(--footer-color) !important;
}
h1.style-signup{
  color: #FFF !important;
    font-size: 1.5em;
}
</style>
